import React, { Fragment, PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { reduxForm } from 'redux-form';

const Content = styled.div`
  background-color: ${({ theme }) => theme.modal.bg};
  .onboarding-header {
    color: ${({ theme }) => theme.text.header};
  }
  > p {
    color: ${({ theme }) => theme.text.text};
  }
  min-height: 26rem;
`;

const StyledP = styled.p`
  margin-bottom: 0px;
`;
export class CreateFundingPassword extends PureComponent {
  state = {
    loading: false,
    skipClicked: false,
  };

  static getDerivedStateFromProps = (props, state) => {
    if (!props.loading && state.loading) {
      return { loading: false };
    }
    return null;
  };

  render = () => {
    const {
      handleSubmit,
      loading,
      invalid,
      isOnboarding,
      handleClose,
    } = this.props;
    return (
      <div className="onboarding-container">
        <Content className="onboarding-content scrollable medium-width">
          <span className="onboarding-header">Onboarding complete!</span>
          {isOnboarding && (
            <Fragment>
              <StyledP>You are all set!</StyledP>
              <StyledP>
                Your account has been created and is ready for use.
              </StyledP>
              <StyledP>Please click “Continue” to access the portal.</StyledP>
              <Button
                data-dd-action-name="complete-onboarding-btn"
                loading={this.state.loading || loading}
                className="top-button submit"
                onClick={() => {
                  this.setState({ loading: true }, () => handleSubmit());
                }}
                primary
                type="submit"
                disabled={
                  invalid ||
                  this.state.loading ||
                  loading ||
                  this.state.skipClicked
                }
              >
                Continue
              </Button>
            </Fragment>
          )}
        </Content>
      </div>
    );
  };
}

CreateFundingPassword.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool,
};

CreateFundingPassword.defaultProps = {
  invalid: true,
};

export default reduxForm({
  form: 'funding_password',
})(CreateFundingPassword);
